module.exports = __webpack_public_path__ + "static/media/image_vectorheart.93a3ed98.svg";